<script setup>
import { useI18n } from 'vue-i18n';
import PostSaleStatusFields from './PostSaleStatusFields.vue';

defineProps({
  catalog: { type: Object, default: () => ({}) },
  deliveryForecastRequired: { type: Boolean, default: false },
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
  modelValue: { type: String, default: '' },
  postSaleCaseId: { type: [Number, String], default: '' },
  statusOptions: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'update:modelValue',
  'updateDeliveryForecast',
  'updateReason',
]);
const { t } = useI18n();
</script>

<template>
  <div>
    <div
      class="grid gap-4 pb-4"
      :class="deliveryForecastRequired ? 'sm:grid-cols-2' : 'sm:grid-cols-1'"
    >
      <label
        class="flex flex-col gap-1 text-sm font-semibold text-lais-text-body"
      >
        {{ t('POST_SALE.TRANSITION.STATUS') }}
        <select
          :value="modelValue"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
          @change="emit('update:modelValue', $event.target.value)"
        >
          <option
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </label>
      <label
        v-if="deliveryForecastRequired"
        class="flex flex-col gap-1 text-sm font-semibold text-lais-text-body"
      >
        {{ t('POST_SALE.TRANSITION.DELIVERY_FORECAST') }}
        <input
          :value="form.status_due_at"
          data-testid="post-sale-delivery-forecast"
          type="text"
          :aria-invalid="Boolean(errors.status_due_at)"
          :placeholder="t('POST_SALE.TRANSITION.DELIVERY_FORECAST_PLACEHOLDER')"
          maxlength="10"
          class="min-h-10 rounded-lais border px-2 font-normal"
          :class="
            errors.status_due_at ? 'border-red-500' : 'border-lais-border'
          "
          @input="emit('updateDeliveryForecast', $event)"
        />
        <span
          v-if="errors.status_due_at"
          class="text-xs font-normal text-red-600"
        >
          {{
            errors.status_due_at === 'INVALID_DATE'
              ? t('POST_SALE.FORM.VALIDATION.INVALID_DATE')
              : t('POST_SALE.FORM.VALIDATION.REQUIRED')
          }}
        </span>
      </label>
    </div>

    <PostSaleStatusFields
      :catalog="catalog"
      :errors="errors"
      :post-sale-case-id="postSaleCaseId"
      :status="modelValue"
      :form="form"
    />

    <label
      class="mt-4 flex flex-col gap-1 text-sm font-semibold text-lais-text-body"
    >
      {{ t('POST_SALE.TRANSITION.OBSERVATION') }}
      <textarea
        :value="form.reason"
        rows="3"
        class="rounded-lais border border-lais-border p-2 font-normal"
        :placeholder="t('POST_SALE.TRANSITION.OBSERVATION_PLACEHOLDER')"
        @input="emit('updateReason', $event.target.value)"
      />
    </label>
  </div>
</template>
